<template>
  <v-list
    v-if="methods && methods.length"
  >
    <div
      v-for="(method, index) in getAvailableMethods"
      :key="`${index}-method`"
    >
      <v-list-tile
        @click="$emit('selectMethod', method)"
      >
        <v-list-tile-content>
          <v-list-tile-title
          >
            {{ method.name }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider
        v-if="index !== methods.length-1"
      />
    </div>
  </v-list>
  <loading-state
    v-else
    :loading="true"
  />
</template>

<script>
import LoadingState from '@/components/LoadingState'

export default {
  name: 'PaymentList',

  components: {
    LoadingState
  },

  actionBar () {
    return {
      title: 'Payment Settings'
    }
  },

  props: {
    methods: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      pluginsList: [],
      methodsList: [],
      pluginMethods: {
        'converge': 'futureecom/converge-payment-plugin',
        'tranzila': 'futureecom/tranzila-payment-plugin'
      }
    }
  },

  computed: {
    getAvailableMethods () {
      return this.methods.filter(method => {
        if (!this.pluginMethods[method.code]) {
          return true
        }

        const pluginMethod = this.pluginsList[this.pluginMethods[method.code]] || null
        return pluginMethod && pluginMethod.enabled
      })
    }
  },

  async created () {
    this.pluginsList = await this.$http.make('settings').getPluginsList()
  }
}
</script>
